/**
 * Bridges the plain-Vuex import actions (file-operations.ts) to the
 * GpxImportChoiceDialog component instance mounted by TrailImportDialog.vue.
 * Vuex actions have no `this.$refs`, so the mounted instance registers itself
 * here and the action calls the exported function directly.
 */
export type GpxImportChoice = 'route' | 'waypoints' | 'both';

interface GpxImportChoiceDialogInstance {
  prompt(waypointCount: number): Promise<GpxImportChoice | null>;
}

let dialogInstance: GpxImportChoiceDialogInstance | null = null;

export function registerGpxImportChoiceDialog(instance: GpxImportChoiceDialogInstance) {
  dialogInstance = instance;
}

export function promptGpxImportChoice(waypointCount: number): Promise<GpxImportChoice | null> {
  if (!dialogInstance) {
    // Dialog isn't mounted (shouldn't happen inside the hike planner) — fall back to
    // importing everything rather than silently dropping the parsed waypoints.
    return Promise.resolve('both');
  }
  return dialogInstance.prompt(waypointCount);
}
